import { getContext } from '@fiverr-private/fiverr_context';

export const isSignUpRequired = () => {
    const { userId } = getContext();

    return !userId;
};

export const isMigrationRequired = () => {
    const {
        organizationId,
        experience: { isBusiness },
    } = getContext();
    const isMarketplaceUserInPro = isBusiness && !organizationId;

    return isMarketplaceUserInPro;
};

/**
 * @returns true if the user is not logged in or is a marketplace user in pro experience.
 */
export const isSignUpOrMigrationRequired = () => isSignUpRequired() || isMigrationRequired();
